import { Placement } from '@popperjs/core';
import Icon from 'flow/components/ui-components/Icon';
import Popover from 'flow/components/ui-components/Popover';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';

type Props = {
    children: React.ReactNode;
    closeOnMouseLeave?: boolean;
    popoverClassName?: string;
    onClick?: () => void;
    icon?: React.ReactNode;
    placement?: Placement;
    preventOverflow?: boolean;
    backgroundColor?: string;
    onClickOpen?: () => void;
    /** Names the icon-only trigger for assistive tech; see Popover. */
    triggerLabel?: string;
};

const PopoverMenu = ({
    closeOnMouseLeave,
    children,
    popoverClassName = '',
    icon,
    placement,
    preventOverflow = false,
    backgroundColor,
    onClickOpen,
    triggerLabel,
}: Props) => {
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);

    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: placement,
        modifiers: [
            {
                name: 'flip',
                enabled: true,
                options: {
                    flipVariations: true,
                    allowedAutoPlacements: [
                        'bottom-start',
                        'top-start',
                        'bottom-end',
                    ],
                },
            },
            { name: 'preventOverflow', enabled: preventOverflow },
        ],
    });

    return (
        <Popover
            icon={
                <div ref={setReferenceElement} className="flex">
                    {icon || (
                        <Icon className="cursor-pointer" iconKey="more_vert" />
                    )}
                </div>
            }
            onClickOpen={onClickOpen}
            className={popoverClassName}
            closeOnMouseLeave={closeOnMouseLeave}
            backgroundColor={backgroundColor}
            placement={placement}
            triggerLabel={triggerLabel}
        >
            {createPortal(
                <div
                    ref={setPopperElement}
                    style={styles.popper}
                    {...attributes.popper}
                    className="z-50 -me-2 mt-2"
                >
                    {children}
                </div>,
                document.getElementById('contextMenuPortal'),
            )}
        </Popover>
    );
};

export default PopoverMenu;
